import { useSyncExternalStore } from "react";
import { snapshot, subscribe } from "valtio";

/**
 * For stores written only on the client: parts of the page that hydrate later (Suspense boundaries) first render
 * the server state, so their markup matches, and switch to the client state right after.
 */
export const createHydrationSafeSnapshotHook = <T extends object>(store: T) => {
    const serverSnapshot = snapshot(store);
    const subscribeToStore = (onChange: () => void) => subscribe(store, onChange);
    const getSnapshot = () => snapshot(store);
    const getServerSnapshot = () => serverSnapshot;

    return () => useSyncExternalStore(subscribeToStore, getSnapshot, getServerSnapshot);
};
